<template>
    <modal ref="modal" style="z-index: 9999"  class="fade"  header="error" :needFooter="true">
        <template v-slot:header>
            <div class="me-3">
                <span class="fw-bolder h3" @click="$refs.modal.close()" data-bs-dismiss="modal" aria-label="Close">
                    <i class="fal fa-times text-white"></i>
                </span>
            </div>
            <div class="w-100 pe-3 text-truncate">
                <span class="fw-bolder h4">{{errorObj ? errorObj.error.message:''}}</span>
            </div>
        </template>

        <div v-if="errorObj" v-for="items in errorObj.error.errors">
            <div v-for="item in items"><b><span v-html="nlbr(item)"></span></b></div>
        </div>
        <template v-slot:footer>
            <button @click="$refs.modal.close()" class="btn rounded-pill btn-secondary">{{$t('app.close')}}</button>
        </template>
    </modal>
</template>
<script>
    export default {
        name: "notification-modal",
        data() {
            return {errorObj: null}
        },
        components: {
        },
        mounted() {
            this.emitter.on('validationError', error => {
                console.log('master', error)
                this.errorObj = error;
                this.$refs.modal.open();
            })
        },
        methods: {
            open() {
                this.$refs.modal.open();
            },
            nlbr(str){
                return str.replace("\n", '<br />')
            }
        }
    }
</script>

<style scoped>
.btn{
    min-width: 100px;
}
</style>
